import { render, staticRenderFns } from "./MobFooter.vue?vue&type=template&id=38d2e8f4&scoped=true&"
import script from "./MobFooter.vue?vue&type=script&lang=js&"
export * from "./MobFooter.vue?vue&type=script&lang=js&"
import style0 from "./MobFooter.vue?vue&type=style&index=0&id=38d2e8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d2e8f4",
  null
  
)

export default component.exports